import React, { useEffect, useState } from 'react'
import { Field, ErrorMessage } from 'formik'
import { format_append, format_currency, format_phone, format_ein, format_ssn, sanitize_special } from './util'

const isBrowser = typeof window !== "undefined"

export const Checkbox = ({
  field,
  form: { values, touched, errors, setFieldValue },
  ...props
}) => (
  <Field {...props} name={field.name} type="checkbox" checked={field.value.includes(props.value)} onChange={() => {
    if (field.value.includes(props.value)) {
      return setFieldValue(field.name, field.value.filter(value => {
        return value !== props.value
      }))
    }

    return setFieldValue(field.name, field.value.concat(props.value))
  }} />
)
export const CurrencyMask = ({
  field,
  form: { values, touched, errors, setFieldValue },
  ...props
}) => (
  <input type="text" {...field} {...props} onKeyUp={e => {
    if (e.key === ',') return
    return setFieldValue(field.name, format_currency(sanitize_special(e.target.value)))
  }} placeholder="(USD)" />
)

export const EINMask = ({
  field,
  form: { values, touched, errors, setFieldValue },
  ...props
}) => (
  <input type="text" {...field} {...props} onKeyUp={e => {
    if (e.key === '-' || e.key === 'Backspace') return
    return setFieldValue(field.name, format_ein(sanitize_special(e.target.value)))
  }} />
)
export const ErrorText = ({ children }) => (
  <span className="helper-text red-text">
    {children}
  </span>
)
export const ErrorSummary = ({ errors, touched, values, isSubmitting }) => (
  <div className="row">
    <div className="col s12">
      <h6 className={Object.keys(errors).length ? 'helper-text red-text' : 'helper-text'}>{Object.keys(errors).length ? "A required field is missing. Please review the errors below." : "*Marks Required Fields"}</h6>
    </div>
  </div>
)
const Dropdown = ({options, add}) => {
  return (
    <div className="absolute shadow top-100 bg-white z-2 w-1/4 max-h-select overflow-y-auto">
      <div className="flex flex-col w-full">
          {
            options.map((item, key) => {
              return (
                <div key={key} className="cursor-pointer w-full hover:bg-azul hover:text-white" onClick={() => add(item)}>
                  <div className="flex w-full items-center p-2 pl-2 border-transparent border-l-2 relative hover:border-teal-100" >
                    <div className="w-full items-center flex dropdown-item">
                      <div className="mx-2 leading-6 dropdown-item">
                        { item }
                      </div>
                    </div>
                  </div>
                </div>
              )
            })
          }
      </div>
    </div>
  )
}
export const MultiSelect = ({
  field,
  options,
  label,
  form: { setFieldValue, setFieldTouched },
  ...props
}) => (
  <select {...props} name={field.name} multiple={true}>
    <option key="default" value="">{label === undefined ? "Choose all that apply..." : label}</option>
    {options.map((item, key) => (
      <option key={key} value={item}>{item}</option>
    ))}
  </select>
)
export const MultiSelectMenu = ({
  field,
  options,
  label,
  form: { setFieldValue, setFieldTouched },
  ...props
}) => {
  const [dropdown, set_dropdown] = useState(false)
  const body =  isBrowser ? document.querySelector('body') : null
  const add = (value) => {
    setFieldTouched(field.name, true)
    return setFieldValue(field.name, field.value.concat([value]))
  }
  const remove = (value) => {
    return setFieldValue(field.name, field.value.filter(tag => {
      return tag !== value
    }))
  }
  const toggle = () => {
    set_dropdown(!dropdown)
  }
  const handle = e => {
    if (dropdown && !e.target.className.includes('dropdown-item')) {
      set_dropdown(false)
    }
  }

  useEffect(() => {
    body.addEventListener('click', handle)

    return () => {
      body.removeEventListener('click', handle)
    }
  })

  return (
    <div className="autcomplete-wrapper">
      <div className="autcomplete">
        <div className="w-full flex flex-col items-center mx-auto">
          <div className="w-full">
            <div className="flex flex-col items-center relative">
              <div className="w-full">
                <div className="border border-black w-full leading-tight flex">
                  <div className="flex flex-auto flex-wrap">
                    {
                      field.value.map((tag, index) => {
                        return (
                          <div key={index} className="flex justify-center items-center m-1 font-medium py-1 px-2 rounded border bg-ice">
                            <div className="text-xs font-normal leading-none max-w-full flex-initial">{ tag }</div>
                            <div className="flex flex-auto flex-row-reverse">
                              <div onClick={() => remove(tag)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" 
                                className="feather feather-x cursor-pointer hover:text-darkazul rounded-full w-4 h-4 ml-2">
                                  <line x1="18" y1="6" x2="6" y2="18"></line>
                                  <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                              </div>
                            </div>
                          </div>
                        )
                      })
                    }
                    <div className="flex-1">
                      <input placeholder="" className="bg-transparent py-2 px-4 appearance-none outline-none h-full w-full" onClick={toggle} />
                    </div>
                  </div>
                  <div className="w-8 py-1 pl-2 pr-1 border-l flex items-center border" onClick={toggle}>
                    <button className="cursor-pointer w-6 h-6 text-gray-600 outline-none focus:outline-none">
                      {
                        dropdown ?
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" 
                        className="feather feather-x cursor-pointer hover:text-darkazul rounded-full w-4 h-4">
                          <line x1="18" y1="6" x2="6" y2="18"></line>
                          <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg> :
                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up w-4 h-4">
                          <polyline points="18 15 12 9 6 15"></polyline>
                        </svg>
                      }
                    </button>
                  </div>
                </div>
              </div>
            </div>
            { dropdown  ? <Dropdown options={options.filter(opt => {
              return !field.value.includes(opt)
            })} add={add}></Dropdown>: null }
          </div>
        </div>
      </div>
    </div>
  )
}
export const PhoneMask = ({
  field,
  form: { values, touched, errors, setFieldValue },
  ...props
}) => (
  <input type="tel" {...field} {...props} onKeyUp={e => {
    if (e.key === '-' || e.key === 'Backspace') return
    if (e.target.value.length > 1) {
      return setFieldValue(field.name, format_phone(sanitize_special(e.target.value)))
    }
  }} placeholder="1-###-###-####" pattern="[0-9]{1}-[0-9]{3}-[0-9]{3}-[0-9]{4}" />
)
export const SSNMask = ({
  field,
  form: { values, touched, errors, setFieldValue },
  ...props
}) => (
  <input type="text" {...field} {...props} onKeyUp={e => {
    if (e.key === '-' || e.key === 'Backspace') return
    if (e.target.value.length > 1) {
      return setFieldValue(field.name, format_ssn(sanitize_special(e.target.value)))
    }
  }} placeholder="###-##-####" pattern="[0-9]{3}-[0-9]{2}-[0-9]{4}" />
)
export const PercentMask = ({
  field,
  form: { values, touched, errors, setFieldValue },
  ...props
}) => (
  <input type="text" {...field} {...props} onKeyUp={e => {
    if (e.key === '%' || e.key === 'Backspace') return
    return setFieldValue(field.name, format_append(sanitize_special(e.target.value), "%", 3))
  }} placeholder="100%" pattern="[0-9]{1,3}%" />
)
export const RadioFieldGroup = ({
  field,
  options,
  label,
  small,
  form: { touched, errors },
}) => (
  <div className="input-field">
    <h6 className={touched[field.name] && errors[field.name] ? 'invalid' : ''}>{label}</h6>
    {small !== undefined ?  <small>{small}</small> : null}
    <ErrorMessage component={ErrorText} name={field.name} />
    {options.map(({value, label}, idx) => (
      <p key={idx}>
        <label>
          <Field name={field.name} className={field.name} type="radio" value={value} checked={value === field.value} />
          <span>{label}</span>
        </label>
      </p>
    ))}
  </div>
)

export const CheckboxFieldGroup = ({
  field,
  options,
  label,
  small,
  form: { touched, errors },
}) => (
  <div className="input-field">
    <h6 className={touched[field.name] && errors[field.name] ? 'invalid' : ''}>{label}</h6>
    {small !== undefined ?  <small>{small}</small> : null}
    <ErrorMessage component={ErrorText} name={field.name} />
    {options.map(({value, label}, idx) => (
      <p key={idx}>
        <label>
          <Field name={field.name} className={field.name} component={Checkbox} value={value} checked={value === field.value} />
          <span>{label}</span>
        </label>
      </p>
    ))}
  </div>
)